export class selectedQuestionpaperNaviagtion {
  static readonly type = '[selectedQuestionpaperNaviagtion] qpr';
  constructor(public data: any) {}
}
